import React from 'react';
import { MapPin } from 'lucide-react';
export function AreasOfService() {
  return <section id="service-areas" className="py-16 bg-white" data-id="element-85">
      <div className="container mx-auto px-4" data-id="element-86">
        <div className="text-center mb-12" data-id="element-87">
          <div className="flex justify-center mb-4" data-id="element-88">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-10 h-10" data-id="element-89" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B365D] mb-4" data-id="element-90">
            Areas We Serve
          </h2>
          <p className="text-[#2C3E50] text-lg max-w-3xl mx-auto" data-id="element-91">
            Crown Inspection Services proudly serves communities throughout
            Southwest Florida, including all cities in Lee, Collier, and
            Charlotte counties.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-92">
          <CountySection county="Lee County" cities={[{
          name: 'Fort Myers',
          url: 'https://www.cityftmyers.com'
        }, {
          name: 'Cape Coral',
          url: 'https://www.capecoral.gov'
        }, {
          name: 'Sanibel',
          url: 'https://www.mysanibel.com'
        }, {
          name: 'Fort Myers Beach',
          url: 'https://www.fortmyersbeachfl.gov'
        }, {
          name: 'Bonita Springs',
          url: 'https://www.cityofbonitasprings.org'
        }, {
          name: 'Estero',
          url: 'https://estero-fl.gov'
        }, {
          name: 'Lehigh Acres',
          url: 'https://www.leegov.com/dcd/Planning/CommunityPlans/LehighAcres'
        }]} data-id="element-93" />
          <CountySection county="Collier County" cities={[{
          name: 'Naples',
          url: 'https://www.naplesgov.com'
        }, {
          name: 'Marco Island',
          url: 'https://www.cityofmarcoisland.com'
        }, {
          name: 'Immokalee',
          url: 'https://www.colliercountyfl.gov/your-government/divisions-a-e/community-and-human-services/housing-operations/immokalee-community-redevelopment-agency'
        }, {
          name: 'Golden Gate',
          url: 'https://www.colliercountyfl.gov/your-government/divisions-f-r/operations-management/golden-gate-community-center'
        }, {
          name: 'Ave Maria',
          url: 'https://www.avemaria.com'
        }, {
          name: 'Everglades City',
          url: 'https://www.cityofeverglades.org'
        }]} data-id="element-94" />
          <CountySection county="Charlotte County" cities={[{
          name: 'Punta Gorda',
          url: 'https://www.cityofpuntagorda.com'
        }, {
          name: 'Port Charlotte',
          url: 'https://www.charlottecountyfl.gov'
        }, {
          name: 'Englewood',
          url: 'https://www.charlottecountyfl.gov/departments/community-services/recreation/recreation-centers/englewood-recreation-center.stml'
        }, {
          name: 'Rotonda West',
          url: 'https://www.charlottecountyfl.gov'
        }, {
          name: 'Charlotte Harbor',
          url: 'https://www.charlottecountyfl.gov'
        }]} data-id="element-95" />
        </div>
        <div className="mt-12 bg-[#F8F9FA] rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-96">
          <div className="flex items-start" data-id="element-97">
            <div className="bg-[#D4AF37] text-[#1B365D] p-2 rounded mr-4 flex-shrink-0" data-id="element-98">
              <MapPin size={24} data-id="element-99" />
            </div>
            <div data-id="element-100">
              <h4 className="font-bold text-[#1B365D] text-lg mb-2" data-id="element-101">
                Serving All of Southwest Florida
              </h4>
              <p className="text-[#2C3E50]" data-id="element-102">
                Don't see your city listed? We serve all communities in Lee,
                Collier, and Charlotte counties. Contact us at{' '}
                <a href="tel:2396997080" className="text-[#0077BE] font-bold hover:underline" data-id="element-103">
                  239-699-7080
                </a>{' '}
                to schedule your inspection, no matter where you're located in
                Southwest Florida.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
interface City {
  name: string;
  url: string;
}
interface CountySectionProps {
  county: string;
  cities: City[];
}
function CountySection({
  county,
  cities
}: CountySectionProps) {
  return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-lg p-6" data-id="element-104">
      <h3 className="text-xl font-bold text-[#1B365D] mb-4 flex items-center" data-id="element-105">
        <MapPin size={20} className="text-[#0077BE] mr-2" data-id="element-106" />
        {county}
      </h3>
      <ul className="space-y-2" data-id="element-107">
        {cities.map((city, index) => <li key={index} className="flex items-center" data-id="element-108">
            <div className="w-2 h-2 bg-[#D4AF37] rounded-full mr-2" data-id="element-109"></div>
            <a href={city.url} target="_blank" rel="noopener noreferrer" className="text-[#2C3E50] hover:text-[#0077BE] hover:underline transition-colors" data-id="element-110">
              {city.name}
            </a>
          </li>)}
      </ul>
    </div>;
}